import React from "react";
import criticalincidentreportsicon from "../../../assets/images/criticalincidentreportsicon.svg";
import filesforreviewicon from "../../../assets/images/filesforreviewicon.svg";
import resourceicon from "../../../assets/images/resourceicon.svg";
import emergencytrackingicon from "../../../assets/images/emergencytrackingicon.svg";
import { Table,  Badge } from "react-bootstrap";
import './ownerhome.css'
import { GrowIcon } from "../../utility/icons/Icons";
import RescheduleMeetingSection from "../tasks/RescheduleMeetingSection";
import Hometabs from "../hometabs/Hometabs";
import AuditSection from "./AuditSection";

const OwnerHome: React.FC = () => {
    return (
        <>
            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-4">
                    <div className="common_card h-100">
                        <div className="top border_tittle mb-0 border-0">
                            <div className="top_bar_tittle">
                                <h2>Operations</h2>
                            </div>
                        </div>
                        <Table className="operations_table mb-0">
                            <thead>
                                <tr>
                                    <th style={{ width: '15rem' }}>Type</th>
                                    <th>Open</th>
                                    <th>Flag</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="operation_type">
                                            <div className="icon_color_bg red">
                                                <img src={criticalincidentreportsicon} alt="criticalincidentreportsicon" />
                                            </div>
                                            <div className="operation_type_txt">
                                                <p>Critical Incident  <br /> Reports</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>2</td>
                                    <td><span>2</span></td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="operation_type">
                                            <div className="icon_color_bg green">
                                                <img src={resourceicon} alt="resourceicon" />
                                            </div>
                                            <div className="operation_type_txt">
                                                <p>Resource <br /> Request</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>103</td>
                                    <td><span>3</span></td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="operation_type">
                                            <div className="icon_color_bg blue">
                                                <img src={filesforreviewicon} alt="filesforreviewicon" />
                                            </div>
                                            <div className="operation_type_txt">
                                                <p>Files For <br /> Review</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>102</td>
                                    <td><span>2</span></td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="operation_type">
                                            <div className="icon_color_bg yellow">
                                                <img src={emergencytrackingicon} alt="emergencytrackingicon" />
                                            </div>
                                            <div className="operation_type_txt">
                                                <p>Emergency <br /> Tracking</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>1010</td>
                                    <td><span>10</span></td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-4">
                    {/* Audit Section  */}
                    <AuditSection />
                </div>
                            
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-4">
                    <div className="common_card h-100">
                        <div className="top border_tittle mb-0 border-0">
                            <div className="top_bar_tittle">
                                <h2>Finance</h2>
                            </div>
                        </div>
                        <div className="finance_card_list">
                            <div className="finance_card">
                                <div className="finance_card_top">
                                    <h3>Billing</h3>
                                    <p>442 Billable</p>
                                </div>
                                <div className="finance_card_body">
                                    <div className="finance_card_txt">
                                        <p>Billed</p>
                                        <h4>$143,000</h4>
                                    </div>
                                    <div className="finance_card_growth">
                                        <p><GrowIcon /> 6.4%</p>
                                    </div>
                                </div>
                            </div>
                            <div className="finance_card">
                                <div className="finance_card_top">
                                    <h3>Participants</h3>
                                    <p>526 Active</p>
                                </div>
                                <div className="finance_card_body">
                                    <div className="finance_card_txt">
                                        <p>Collected</p>
                                        <h4>$143,000</h4>
                                    </div>
                                    <div className="finance_card_growth">
                                        <p><GrowIcon /> 4.1%</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="finance_badge_flx">
                            <div className="finance_badge">
                                <div className="my_badge">
                                    <Badge bg="primary">AR $482,000</Badge>
                                </div>
                                <div className="my_badge">
                                    <Badge bg="warning">L2B 34d</Badge>
                                </div>
                                <div className="my_badge">
                                    <Badge bg="danger">Denials 18%</Badge>
                                </div>
                            </div>
                            <div className="finance_badge_txt">
                                <p>84% Billable</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-4">
                    <RescheduleMeetingSection />
                </div>
                <div className="col-md-12 col-lg-12 col-xl-8">
                    <div className="ownerdashborad_hometabs">
                        <Hometabs />
                    </div>
                </div>
            </div>
        </>
    );
};

export default OwnerHome;
